<template>

    <frontend-fullscreen-layout>
        <Head title="Log in"/>
        <div class="w-100 h-[calc(100vh)] bg-gray-100">
            <div class="m-auto max-w-lg pt-24">
                <div class="flex justify-center items-center mb-16">
                    <img
                        src="/storage/site_assets/logos/site_logo.png"
                        class="w-[240px]"
                    />
                </div>
                <div class="rounded border border-gray-100 bg-white p-8 shadow">
                    <div
                        class="mb-6 text-[28px] font-semibold leading-none tracking-tight"
                    >
                        Log In
                    </div>

                    <div
                        class=""
                        v-if="$page.props.site_config.enabled_login_signup"
                    >
                        <form @submit.prevent="submit" name="login_form">
                            <div>
                                <form-input
                                    label="Email"
                                    id="email"
                                    type="email"
                                    name="email"
                                    :hide-errors="true"
                                    v-model="form.email"
                                    :autofocus="true"
                                    autocomplete="username"
                                />
                            </div>

                            <div class="relative mt-4">
                                <form-input
                                    label="Password"
                                    id="password"
                                    type="password"
                                    name="password"
                                    :hide-errors="true"
                                    v-model="form.password"
                                    autocomplete="current-password"
                                />

                                <div class="absolute -top-1 right-0">
                                    <Link
                                        v-if="canResetPassword"
                                        :href="route('password.request')"
                                        class="link text-[14px]"
                                    >
                                        Forgot password?
                                    </Link>
                                </div>
                            </div>

                            <div class="mt-8 flex items-center">
                                <button
                                    :class="
                                        'btn btn-primary w-full text-center' +
                                        ' ' +
                                        { 'opacity-25': form.processing }
                                    "
                                    :disabled="
                                        !form.email ||
                                        !form.password ||
                                        form.processing
                                    "
                                    @button-click="submit()"
                                >
                                    Log in
                                </button>
                            </div>
                        </form>
                        <div class="flex items-center justify-center">
                            <form-errors
                                form-name="login_form"
                                fields="email,password"
                            />
                        </div>
                    </div>
                    <div class="" v-else>
                        Login is currently disabled. Please come back later.
                    </div>
                </div>

                <div
                    v-if="status && status === 'passwords.reset'"
                    class="mt-4 rounded bg-green-100 p-4 text-[24px] leading-snug text-green-400"
                >
                    <span class="block font-semibold capitalize">Success!</span>
                    <span>
                        Your password has been reset successfully, you may now
                        log in using the updated password.
                    </span>
                </div>

                <div class="my-4 w-full text-center text-[14px] text-gray-900">
                    Don't have an account?
                    <a class="link link-primary underline" :href="route('frontend.pricing')"
                    >Sign Up
                    </a>
                </div>
            </div>

            <div
                class="bg-orange-1100 p-4 text-center"
                v-if="
                    $page.props.env === 'development' ||
                    $page.props.env === 'dev' ||
                    $page.props.env === 'local'
                "
            >
                <div class="mb-2" v-for="user in $page.props.testUsers">
                    <Link
                        class="btn btn-primary"
                        href="/laravel-login-link-login"
                        method="post"
                        as="button"
                        :data="{
                            email: user.email,
                            redirect_url: 'dashboard',
                        }"
                    >
                        Login as {{ user.email }}
                    </Link>
                </div>

            </div>
        </div>
    </frontend-fullscreen-layout>
</template>

<script>

import FrontendFullscreenLayout from '../../_Layouts/FrontendFullscreenLayout.vue'
import FormInput from '../../Components/FormInput.vue'
import FormErrors from '../../Components/FormErrors.vue'

export default {
    name: 'Login',
    components: { FormErrors, FormInput, FrontendFullscreenLayout },
    props: {
        canResetPassword: {
            type: Boolean,
            default: false,
        },
        status: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            }),
        }
    },
    methods: {
        submit () {
            this.form.post(route('login'), {
                onFinish: () => this.form.reset('password'),
            })
        },
    },
}
</script>

<style scoped></style>
